import { render, staticRenderFns } from "./ProfileComments.vue?vue&type=template&id=6c8ff403&scoped=true&"
import script from "./ProfileComments.vue?vue&type=script&lang=js&"
export * from "./ProfileComments.vue?vue&type=script&lang=js&"
import style0 from "./ProfileComments.vue?vue&type=style&index=0&id=6c8ff403&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c8ff403",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('6c8ff403', component.options)
    } else {
      api.reload('6c8ff403', component.options)
    }
    module.hot.accept("./ProfileComments.vue?vue&type=template&id=6c8ff403&scoped=true&", function () {
      api.rerender('6c8ff403', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/student-profile/components/comments/ProfileComments.vue"
export default component.exports